import generateToast from './ToastGenerator.js';

export function bindEventsSubscription(rootElement) {
	const subscribeBtn = rootElement.querySelectorAll('.subscription');
	subscribeBtn.forEach(button => {
		if (!button.hasAttribute("data-subscription-init")) {
			button.addEventListener('click', onClick);
			button.setAttribute("data-subscription-init", "");
		}
		else {
		}
	})
}

function onClick(event) {
	let checkUser = event.currentTarget.hasAttribute("data-status");
	checkUser ? unsubscribe(event) : subscribe(event);
}

function subscribe(event) {
	let button = event.currentTarget;
	makeRequest(event)
		.then(() => button.innerText = 'Отписаться').catch(() => { console.log('Subscribe Bug') })
		.then(button.setAttribute("data-status", "Y")).catch(() => { });
}

function unsubscribe(event) {
	let button = event.currentTarget;
	makeRequest(event)
		.then(() => button.innerText = 'Подписаться').catch(() => { console.log('Unsubscribe Bug') })
		.then(button.removeAttribute("data-status")).catch(() => { });
}

function makeRequest(event) {
	return new Promise(function (resolve, reject) {
		let url = event.currentTarget.dataset.url;
		import("axios").then(({ default: axios }) => {
			axios({
				method: 'post',
				url: url,
				responseType: 'json'
			})
				.then(function (response) {
					if (response.data.success) {
						resolve();
						console.log(response);
						generateToast(response.data.data.title, response.data.data.message, '#6EC67B', 'black');
					}
					else {
						reject();
						generateToast(response.data.data.title, response.data.data.message, '#FF0037', 'white');
					}
				})
				.catch(function (response) {
					reject();
					console.log(response);
					generateToast(response.data.data.title, response.data.data.message, '#FF0037', 'white');
				});
		})
	})
}
